import React from 'react';
import './updatePassword.css';
import SectionLayout from './../../../../CommonComponents/Layout/sectionLayout';
import CommonPageHeroText from './../../../../CommonComponents/CommonPageHeroText/index';
import UpdatePasswordForm from './UpdatePassForm/index';
import useLocalization from '../../../../../Localization';
const ResetUpdatePassComponent = () => {
  const {ApplicationString} = useLocalization();
  return (
    <React.Fragment>
      <CommonPageHeroText
        heading={ApplicationString['userResetPasswordComponent.heading']}
        subheading={ApplicationString['userResetPasswordComponent.subheading']}
      />
      <SectionLayout>
        <UpdatePasswordForm />
      </SectionLayout>
    </React.Fragment>
  );
};

export default ResetUpdatePassComponent;
